import React, { useState, useRef, useEffect } from 'react'

import styled from 'styled-components'
import { HiOutlineDotsHorizontal } from 'react-icons/hi'

import { P } from '../style/Typography.style'

const ContextMenu = ({ links }) => {
  const [showMenu, setShowMenu] = useState(false)
  const menuRef = useRef()

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (menuRef.current && !menuRef.current.contains(e.target)) {
        setShowMenu(false)
      }
    }

    document.addEventListener('mousedown', handleClickOutside)
    return () => document.removeEventListener('mousedown', handleClickOutside)
  }, [])

  return (
    <MenuWrapper ref={menuRef}>
      <Icon onClick={() => setShowMenu((prev) => !prev)}>
        <HiOutlineDotsHorizontal />
      </Icon>

      {showMenu && (
        <MenuItems>
          {links.map((link, index) => (
            <li key={index}>
              <P cursor="pointer" onClick={link.clickEvent}>
                {link.name}
              </P>
            </li>
          ))}
        </MenuItems>
      )}
    </MenuWrapper>
  )
}

const MenuWrapper = styled.div`
  position: relative;
  display: inline-block;
`

const Icon = styled.div`
  cursor: pointer;
`

const MenuItems = styled.ul`
  position: absolute;
  top: 100%;
  right: 0;
  z-index: 999;
  list-style: none;
  margin: 0;
  padding: 0.5rem;
  background-color: #fff;
  border: 1px solid #eee;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  min-width: 160px;

  li {
    padding: 0.5rem;
    transition: background 0.2s ease;
  }

  li:hover {
    background-color: #f5f5f5;
  }
`

export default ContextMenu
